module.exports = __webpack_public_path__ + "img/history.310ebf91.svg";